import { useContext } from 'react';
import { CookieConsentContext } from '../context/CookieConsentContext';

export function useCookieConsent() {
  const context = useContext(CookieConsentContext);
  if (!context) {
    throw new Error('useCookieConsent must be used within CookieConsentProvider');
  }
  return context;
}

export default useCookieConsent;
